import { Link, LinkProps } from "@mui/material";
import React from "react";

type Props = {
  href: string;
  children: React.ReactNode;
} & Pick<LinkProps, "color" | "underline" | "aria-label">;

export const ExternalLink = ({
  href,
  children,
  color = "inherit",
  underline = "always",
  "aria-label": ariaLabel,
}: Props) => {
  return (
    <Link
      href={href}
      color={color}
      underline={underline}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={ariaLabel}
    >
      {children}
    </Link>
  );
};
